module.exports = {
	"header": "Spotin and Bonnierförlagen launches co-lab",
	"date": "2022/01/08",
	"imgSrc": "Bonnierforlagen_X_Spotin_news.jpg",
	"imgAlt": "Spotin and Bonnierförlagen",
	"ingress": "Spotin and Bonnierförlagen launch a new way to sell books online.",
	"sections": [
		{
			"paragraphs": [
				"The Luleå-based tech company Spotin develops solutions that connect media and e-commerce by enabling the purchase of products and services directly in all types of digital content. Through a collaboration with Bonnierförlagen, it is now possible to buy books digitally in a new way.",
				"First out is the site 'Barn i stan', a site where you can find information about activities and entertainment available for children and young people between 0-13 years in Stockholm. The site is a popular destination for all adults who want to find information about cultural events and tips on things to do with their children. Initially, Spotin's solution allows the visitor to buy related books, but in the long run also other types of products and services directly from editorial content."
			],
			"quote": {
				"text": "”It is extra fun to be able to offer visitors the opportunity to make direct purchases from our site with Spotin. We go from being a site for tips and information to also offering our visitors the opportunity to buy books in a completely new way. Immediately when you discover an interesting book for your child, you will be able to buy it without having to leave the site”",
				"author": "Ulf Norrby",
				"title": "Founder, CEO and responsible publisher at Barn i stan"
			}
		},
		{
			"paragraphs": [
				"Spotin's founder and CEO, Kristoffer Karlsson, believes that the collaboration is the start of a new e-commerce segment for books. The solution enables purchases in contexts where the consumer is inspired, something that can lead to higher conversion."
			],
			"quote": {
				"text": "“It is exciting to take our technology to new industries in addition to fashion, which we work a lot with today. Today's e-commerce system is not adapted for either customers, brands or publishers and the collaboration with Barn i stan proves there is a demand for our solutions in several categories, as we are now adding more segments for curated and seamless e-commerce. In the coming months, several new publishers and sites will be added for book sales. We see a great demand for the type of collaboration we provide from content creators and publishers. They should be able to focus on creating good editorial content, the rest we solve at Spotin ”",
				"author": "Kristoffer Karlsson",
				"title": "Founder and CEO of Spotin"
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/3/article.json
// module id = 16
// module chunks = 0